// ABOUTME: POST /companies/:id/members: staff add a member to a client company; the backend emails a set-password link.
// ABOUTME: Toasts whether that email went out; a 409 (email taken) is shown in the form; the member list refetches.
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { errorHandler, successHandler } from '../../../utils';
import { warningHandler } from '../../../utils/warning-handler';
import {
  AddCompanyMemberInput,
  AddCompanyMemberOutput,
  CompanyBuilder,
} from '../companies.types';

export const addCompanyMember = (builder: CompanyBuilder) =>
  builder.mutation<AddCompanyMemberOutput, AddCompanyMemberInput>({
    query: ({ companyId, FirstName, LastName, Email }) => ({
      url: `/companies/${companyId}/members`,
      method: 'POST',
      body: { FirstName, LastName, Email },
    }),
    transformResponse: (queryResponse: AddCompanyMemberOutput, _, arg) => {
      if (queryResponse.InviteSent) {
        successHandler(
          arg.lang === 'es'
            ? SuccessMessageEs.MEMBER_ADDED
            : SuccessMessageEn.MEMBER_ADDED,
          true
        );
      } else {
        warningHandler(
          '[addCompanyMember]',
          arg.lang === 'es'
            ? ErrorMessageEs.MemberInviteNotSent
            : ErrorMessageEn.MemberInviteNotSent,
          true
        );
      }
      return queryResponse;
    },
    transformErrorResponse: (error, _, arg) => {
      errorHandler(
        '[addCompanyMember]',
        arg.lang === 'es'
          ? ErrorMessageEs.AddCompanyMember
          : ErrorMessageEn.AddCompanyMember,
        error,
        error.status !== 409
      );
      return error.data;
    },
    invalidatesTags: (_result, _error, { companyId }) => [
      { type: 'Company', id: `members-${companyId}` },
    ],
  });
